import { useTranslation } from 'react-i18next';

import { EmissionValueWithSuffix } from '../../../../../../../../../../../../../../shared/components/emission-value-with-suffix/EmissionValueWithSuffix';
import { DeclaredUnit } from '../../../../../../../../../../../../../../shared/interfaces/IComponentDetails';
import { EmissionSymbol } from '../../../../../../../../../../../../../../shared/interfaces/IFootprint';
import { IWasteTreatment } from '../../../../../../PcfWizard.type';

type MenuProps = {
  filteredWasteTreatments: Partial<IWasteTreatment>[];
  onItemSelect: (item: Partial<IWasteTreatment>) => void;
  onItemMouseDown: (e: React.MouseEvent<HTMLElement>) => void;
};

const Menu = ({
  filteredWasteTreatments,
  onItemMouseDown,
  onItemSelect,
}: MenuProps): JSX.Element => {
  const { t } = useTranslation();

  const getItemLabel = (wasteTreatment: Partial<IWasteTreatment>) => {
    return <span className='white-space-normal'>{wasteTreatment.name}</span>;
  };

  return (
    <div className='relative' onMouseDown={onItemMouseDown}>
      <div className='p-dropdown-panel p-component p-ripple-disabled p-connected-overlay-enter-done z-2 absolute w-full overflow-auto'>
        <div className='p-dropdown-items-wrapper max-h-15rem'>
          <ul className='p-dropdown-items'>
            {filteredWasteTreatments.length > 0 ? (
              <>
                {filteredWasteTreatments?.map((wasteTreatment, index) => {
                  return (
                    <li
                      key={wasteTreatment.id || index}
                      className='p-dropdown-item'
                      onClick={(): void => {
                        return onItemSelect(wasteTreatment);
                      }}
                    >
                      <div className='flex justify-content-between w-full'>
                        <div className='flex w-8'>{getItemLabel(wasteTreatment)}</div>
                        <div className='font-light text-gray-600'>
                          <EmissionValueWithSuffix
                            emissionValue={wasteTreatment?.pcfExcludingBiogenic}
                            declaredUnit={DeclaredUnit.kilogram}
                            unitaryProductAmount={1}
                            emissionSymbol={EmissionSymbol.KG_CO2E}
                            abbreviateUnit={true}
                            emissionValueDecimals={6}
                            numericalValueTextClassName='font-light text-gray-600'
                            suffixTextClassName='font-light text-gray-600'
                          />
                        </div>
                      </div>
                    </li>
                  );
                })}
              </>
            ) : (
              <li className='p-dropdown-item cursor-auto'>
                <div className='flex w-full'>
                  <span>
                    {t(
                      'footprintDetailsPage.sections.calculatePcfSection.injectionMoldingSection.wasteManagementSection.inputs.noWasteTreatmentsFound',
                    )}
                  </span>
                </div>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Menu;
